import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { applyMeta } from "@/seo/RouteMeta";
import { notFoundMeta } from "@/seo/meta";

export default function NotFound() {
  useEffect(() => { applyMeta(notFoundMeta(window.location.pathname)); }, []);
  return (
    <PublicLayout>
      <div data-testid="not-found-page" className="mx-auto max-w-3xl px-5 py-24 sm:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F3DDAE]/80">404</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl">Page not found.</h1>
        <p className="mt-4 text-muted-foreground">This page doesn't exist or has moved.</p>
        <div className="mt-8 flex flex-wrap gap-4 text-sm">
          <Link to="/" data-testid="not-found-home-link" className="btn-aurora inline-flex min-h-[44px] items-center rounded-full px-6">Back to AetherTags</Link>
          <Link to="/blog" data-testid="not-found-guides-link" className="inline-flex min-h-[44px] items-center text-[#5EE6D0] underline underline-offset-4">Guides</Link>
          <Link to="/etsy-tags" data-testid="not-found-tags-link" className="inline-flex min-h-[44px] items-center text-[#5EE6D0] underline underline-offset-4">Etsy Tags</Link>
        </div>
      </div>
    </PublicLayout>
  );
}
